<template>
  <div>
    <vxe-grid
      ref="vxeGrid"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight - 6"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      :span-method="mergeRowMethod"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:isCommon="{ row }">
        <el-tag size="mini" :type="row.isCommon === 'N' ? 'info' : 'light'">
          {{
            row.isCommon === 'N'
              ? $l('INDEX.NO') || '否'
              : $l('INDEX.YES') || '是'
          }}
        </el-tag>
      </template>
      <template v-slot:isSpecify="{ row }">
        <el-tag size="mini" :type="row.isSpecify === 'Y' ? 'light' : 'info'">
          {{
            row.isSpecify === 'Y'
              ? $l('INDEX.YES') || '是'
              : $l('INDEX.NO') || '否'
          }}
        </el-tag>
      </template>
      <template v-slot:isCustomerProvide="{ row }">
        <el-tag
          size="mini"
          :type="row.isCustomerProvide === 'Y' ? 'light' : 'info'"
        >
          {{
            row.isCustomerProvide === 'Y'
              ? $l('INDEX.YES') || '是'
              : $l('INDEX.NO') || '否'
          }}
        </el-tag>
      </template>
      <template v-slot:isFactoryConfirm="{ row }">
        <el-tag
          size="mini"
          :type="row.isFactoryConfirm === '1' ? 'light' : 'info'"
        >
          {{ row.v_isFactoryConfirm }}
        </el-tag>
      </template>
      <template v-slot:expandContent="{ row }">
        <GoodsSpecMaterialTable
          :orderCode="row.orderCode"
          :materialCode="row.materialCode"
          :orderMaterialCode="row.orderMaterialCode"
          :disabled="disabled"
          class="m-2"
        />
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="
                $emit('openEditFormDialog', {
                  type: 'detail',
                  params: { code: row.orderMaterialCode },
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
            v-if="!disabled"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                $emit('openEditFormDialog', {
                  type: 'edit',
                  params: { code: row.orderMaterialCode },
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
            v-if="!disabled"
          >
            <i
              class="el-icon-delete tool-btn"
              @click="del(row.orderMaterialCode)"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_copy') || '复制'"
            placement="top"
            v-if="!disabled"
          >
            <i
              class="el-icon-document-copy tool-btn"
              @click="
                $emit('openEditFormDialog', {
                  type: 'copy',
                  params: { code: row.orderMaterialCode },
                })
              "
            ></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import GoodsSpecMaterialTable from '../edit-form/goods-spec-material-table'
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  components: { GoodsSpecMaterialTable },
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
      },
      tableColumns: tableColumns(this),
      disable: false,
    }
  },
  methods: {
    //单行删除
    del(code) {
      this.$emit('batchDel', [code])
    },
    //批量删除前的验证
    getCheckboxRecords(type = 'code') {
      const data = this.$refs.vxeGrid.getCheckboxRecords()
      if (!data || !data.length) {
        this.$message({
          showClose: true,
          message:
            this.$l('INDEX.tips_question_del_rows') || '请选择需要删除的数据！',
          type: 'warning',
        })
        return
      }

      if (data.length > 20) {
        this.$message({
          showClose: true,
          message:
            this.$l('INDEX.tips_question_max_select_rows') ||
            '最多可选择20行！',
          type: 'warning',
        })
        return
      }

      if (type === 'code') {
        return data.map((row) => {
          return row.orderMaterialCode
        })
      }
      return data
    },
    // 通用行合并函数（将相同多列数据合并为一行）
    mergeRowMethod({ row, _rowIndex, column, visibleData }) {
      const fields = ['groupSpecName']
      const cellValue = row[column.property]
      if (cellValue && fields.includes(column.property)) {
        const prevRow = visibleData[_rowIndex - 1]
        let nextRow = visibleData[_rowIndex + 1]
        if (prevRow && prevRow[column.property] === cellValue) {
          return { rowspan: 0, colspan: 0 }
        } else {
          let countRowspan = 1
          while (nextRow && nextRow[column.property] === cellValue) {
            nextRow = visibleData[++countRowspan + _rowIndex]
          }
          if (countRowspan > 1) {
            return { rowspan: countRowspan, colspan: 1 }
          }
        }
      }
    },
  },
}
</script>
<style lang="scss" scoped></style>
